import React from 'react';
import { Box, IconButton } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

/**
 * Floating lock button overlay for the fretboard
 * Positioned at top-left corner of the fretboard
 */
const FretboardLockOverlay = ({
  isLocked,
  onToggle,
  leftHanded = false
}) => {
  return (
    <Box
      className="fretboard-lock-overlay"
      sx={{
        position: 'absolute',
        top: 0,
        left: leftHanded ? 'auto' : '8px',
        right: leftHanded ? '8px' : 'auto',
        zIndex: 100,
        pointerEvents: 'auto',
      }}
    >
      <IconButton
        onClick={onToggle}
        size="small"
        sx={{
          width: 32,
          height: 32,
          backgroundColor: '#111',
          border: 'none',
          color: 'white',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#1a1a1a',
          },
          '&:active': {
            backgroundColor: '#0a0a0a',
          },
        }}
      >
        {isLocked ? (
          <LockIcon sx={{ fontSize: '1rem' }} />
        ) : (
          <LockOpenIcon sx={{ fontSize: '1rem' }} />
        )}
      </IconButton>
    </Box>
  );
};

export default FretboardLockOverlay;
